export const UNLINK_ORDER = {
    REQUEST: 'PACKAGE.UNLINK_ORDER.REQUEST',
    SUCCESS: 'PACKAGE.UNLINK_ORDER.SUCCESS',
    FAILED: 'PACKAGE.UNLINK_ORDER.FAILED',
};

export const BEGIN_UNLINK_ORDER = "BEGIN_UNLINK_ORDER";
export const END_UNLINK_ORDER = "END_UNLINK_ORDER";
